import { render, staticRenderFns } from "./ShareDraw.vue?vue&type=template&id=228aae92&scoped=true"
import script from "./ShareDraw.vue?vue&type=script&lang=js"
export * from "./ShareDraw.vue?vue&type=script&lang=js"
import style0 from "./ShareDraw.vue?vue&type=style&index=0&id=228aae92&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228aae92",
  null
  
)

export default component.exports